<template>
  <div data-qa="lease-company-details">
    <h4 v-if="hasLeaseCompany">{{ i18n.t('/LeaseCompany/BlockTitle') }}</h4>
    <div class="customer-details">
      <search-lease-company-modal
        :show="showSearchModal"
        :is-purchase-order-page="true"
        @close="showSearchModal = false"
      />
      <app-button
        v-if="!hasLeaseCompany"
        data-qa="search-lease-company-button"
        @click="showSearchModal = true"
        >{{ i18n.t('/LeaseCompany/SearchButton') }}</app-button
      >
      <lease-company-details v-if="hasLeaseCompany" :company="company" />
      <app-button
        v-if="hasLeaseCompany"
        data-qa="deselect-lease-company-button"
        button-class="action-quiet"
        @click="deselectCompany()"
      >
        <svg
          width="15"
          height="15"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2.2"
          aria-hidden="true"
        >
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
        <span>{{ i18n.t('/LeaseCompany/DeselectButton') }}</span>
      </app-button>
    </div>
  </div>
</template>

<script>
import AppButton from '@/components/generic/presentational/atoms/appButton/AppButton.vue'
import SearchLeaseCompanyModal from '@/components/generic/presentational/organisms/searchLeaseCompanyModal/SearchLeaseCompanyModal.vue'
import StoreConnector from '@/helpers/StoreConnector'
import LeaseCompanyDetails from '@/components/generic/presentational/molecules/leaseCompanyDetails/LeaseCompanyDetails.vue'
import { EventBus } from '@/plugins/event-bus'
import { mapGetters } from 'vuex'

export default {
  components: {
    AppButton,
    SearchLeaseCompanyModal,
    LeaseCompanyDetails,
  },
  data() {
    return {
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
      showSearchModal: false,
    }
  },
  computed: {
    ...mapGetters({
      company: 'purchaseOrder/leaseCompany',
    }),
    hasLeaseCompany() {
      return this.company?.Name != null
    },
  },
  methods: {
    async deselectCompany() {
      await StoreConnector.dispatch('purchaseOrder/resetLeaseCompany')
      EventBus.$emit('purchaseOrder/leaseCompanyRemoved')
    },
  },
}
</script>

<style lang="scss" scoped>
h4 {
  margin-top: 1em;
}

.customer-details {
  padding-left: 1em;
}
</style>
